import { inject } from '@angular/core';
import { CanActivateFn, createUrlTreeFromSnapshot } from '@angular/router';
import { ContextService } from '@lr/core';

/** Opens the first firm tab the user is allowed to see. */
export const redirectFirmTab: CanActivateFn = route => {
  const codes = inject(ContextService).getPermissions()?.permissions ?? [];

  if (codes.includes('Firm.View')) {
    return createUrlTreeFromSnapshot(route, ['../details']);
  }

  if (codes.includes('Document.View')) {
    return createUrlTreeFromSnapshot(route, ['../documents']);
  }

  return createUrlTreeFromSnapshot(route, ['/access-denied']);
};
